import { render, staticRenderFns } from "./leave-report.vue?vue&type=template&id=6805fbbc&"
import script from "./leave-report.vue?vue&type=script&lang=js&"
export * from "./leave-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports